import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { updateDeliveryNotes, updateUnit } from './actions';
import classnames from 'classnames';
import Header from './Header';
import Nav from './WizardNav';
import ProgressIndicator from './ProgressIndicator';
import Main from './WizardMain';
import DeliveryNotesInput from './DeliveryNotesInput';
import ContactModal from 'components/ContactModal';
import EditModal from './EditModal';
import RadioOption from './RadioOption';
import { TextButton } from 'scy/buttons';
import { textOverflow } from 'scy/utils.mod.scss';
import border from 'scy/border.mod.scss';
import margin from 'scy/margin.mod.scss';

export default function Where({ prevPath, nextPath }) {
  const dispatch = useDispatch();
  const state = useSelector(state => state.giftClaim);
  const { contactNumber } = state;
  const order = state.order || {};
  const customer = order.customer || {};
  const addressDetails = order.delivery_address_detail || {};

  const [isRequestingChange, setIsRequestingChange] = useState(false);
  const [showContactModal, setShowContactModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);

  return (
    <>
      <Header />

      <Nav prevPath={prevPath}>
        <ProgressIndicator steps={{ where: 'active' }} />
      </Nav>

      <Main
        customer={customer}
        title="Where would you like it delivered?"
        nextPath={isRequestingChange ? null : nextPath}
      >
        <div className={classnames(border.top, border.bottom)}>
          <RadioOption
            id="addressDefault"
            name="address"
            checked={!isRequestingChange}
            onChange={() => setIsRequestingChange(false)}
          >
            <div className={textOverflow}>
              {`${addressDetails.address}${
                addressDetails.unit ? `, ${addressDetails.unit}` : ''
              }`}
            </div>
          </RadioOption>

          <DeliveryNotesInput
            deliveryNotes={order.delivery_notes}
            handleChange={notes => dispatch(updateDeliveryNotes(notes))}
            handleEditClick={() => setShowEditModal(true)}
          />
        </div>

        <div className={classnames(border.bottom, margin.bottom_md)}>
          <RadioOption
            id="addressChange"
            name="address"
            checked={isRequestingChange}
            onChange={() => {
              setIsRequestingChange(true);
              setShowContactModal(true);
            }}
          >
            {!isRequestingChange ? (
              'Contact Support to Change'
            ) : (
              <TextButton noUnderline onClick={() => setShowContactModal(true)}>
                Contact Support to Change
              </TextButton>
            )}
          </RadioOption>
        </div>
      </Main>

      <ContactModal
        isOpen={showContactModal}
        handleClose={() => setShowContactModal(false)}
        phoneNumber={contactNumber}
      />

      <EditModal
        order={order}
        isOpen={showEditModal}
        handleClose={() => setShowEditModal(false)}
        updateNotes={notes => dispatch(updateDeliveryNotes(notes))}
        updateUnit={unit => dispatch(updateUnit(unit))}
      />
    </>
  );
}
